import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=580f55ee"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580f55ee')) {
      api.createRecord('580f55ee', component.options)
    } else {
      api.reload('580f55ee', component.options)
    }
    module.hot.accept("./reset-password.vue?vue&type=template&id=580f55ee", function () {
      api.rerender('580f55ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/reset-password.vue"
export default component.exports